"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = requireAccessToken;
const constants_1 = require("../constants");
function requireAccessToken(req, res, next) {
    if (!req.headers[constants_1.RequestHeaders.AccessToken] && !req.session?.accessToken) {
        res.sendStatus(401);
    }
    else {
        next();
    }
}
